import more7days from '@/functions/more7days'
export default function getMItem(bizId: string) {
    const allTokens = localStorage.getItem('allTokens') ? JSON.parse(localStorage.getItem('allTokens')) : {}
    console.log('allTokens', allTokens)
    const curTime = new Date().getTime()
    const miniTimeH5 = localStorage.getItem('deadTime') || 0
    if (miniTimeH5 === 0 || more7days(curTime, miniTimeH5)) {
        // 清空过期的allTokens
        console.log('清理过期的token')
        localStorage.setItem('allTokens', '')
        console.log('miniTimeH5', miniTimeH5)
        console.log('more7days(curTime, miniTimeH5)', more7days(curTime, miniTimeH5))
        return ''
    }
    return allTokens[bizId]
}
